// ─── Máximo por producto ──────────────────────────────────────
const MAX_QTY = 1;

// ─── Posición dinámica del carrito según el header real ───────
function updateCartPosition() {
  const cart = document.getElementById('floating_cart_id');
  if (!cart) return;

  const header = document.querySelector('header')
              || document.querySelector('.site-header')
              || document.querySelector('#shopify-section-header');

  if (!header) return;

  const offset = Math.max(0, header.getBoundingClientRect().bottom) - 1;
  cart.style.top    = offset + 'px';
  cart.style.height = `calc(100vh - ${offset}px)`;
  cart.style.setProperty('--cart-top', offset + 'px');
}

window.addEventListener('scroll', updateCartPosition, { passive: true });
window.addEventListener('resize', updateCartPosition);

// ─── Resolver qué contenedor abrir según la página actual ─────
function resolveCartContainer() {
  const isCheckoutCart = window.location.pathname === '/pages/checkout-cart';
  return isCheckoutCart
    ? document.getElementById('open-cart')
    : document.getElementById('floating_cart_id');
}

// ─── Scope del snippet — nunca colisiona con CartAPI ─────────
function getCartScopes() {
  return document.querySelectorAll('.cart-container');
}

// ─── Toggle / open del carrito ────────────────────────────────
function toggleCart() {
  const container = resolveCartContainer();
  if (container) container.classList.toggle('active');
  document.getElementById('cart-summary')?.classList.toggle('container');
  const isOpen = container.classList.contains('active');
  // B5 (/probar 26-10): solo se recuerda dentro del checkout; abierto en otra página y seguido el
  // enlace al checkout, salía encima del paso 1
  if (window.location.pathname === '/pages/checkout-cart') sessionStorage.setItem('cart_open_state', isOpen ? '1' : '0');
  else sessionStorage.setItem('cart_open_state', '0');
}

function openCart() {
  updateCartPosition(); // ahora está en scope global ✓
  resolveCartContainer()?.classList.add('active');
  // B5 (/probar 26-10): el carrito que se abre al agregar en otra página no se recuerda; si no,
  // /pages/checkout-cart salía con el carrito lateral abierto encima del paso 1
  if (window.location.pathname === '/pages/checkout-cart') sessionStorage.setItem('cart_open_state', '1');
}

// ─── Restaurar estado al cargar la página ─────────────────────
function isMobileOrTablet() {
  return window.matchMedia('(max-width: 1024px)').matches;
}

function restoreCartState() {
  const isCheckoutCart = window.location.pathname === '/pages/checkout-cart';
  if (!isCheckoutCart) return;

  // Si es móvil o tablet, limpiar sesión y no restaurar estado
  if (isMobileOrTablet()) {
    sessionStorage.removeItem('cart_open_state');
    return;
  }

  // Solo en desktop: restaurar estado del carrito
  if (sessionStorage.getItem('cart_open_state') === '1') {
    resolveCartContainer()?.classList.add('active');
    document.getElementById('cart-summary')?.classList.remove('container');
  }
}

// ─── Delegación en document ───────────────────────────────────
document.addEventListener('click', (event) => {
  if (event.target.closest('#btn-cart-header')) {
    toggleCart();
    return;
  }

  if (event.target.closest('#btn_cart_close') || event.target.closest('#btn_back_to_cart')) {
    document.getElementById('cart-summary')?.classList.add('container');
    resolveCartContainer()?.classList.remove('active');
    sessionStorage.setItem('cart_open_state', '0');
    return;
  }

  // B3 (/probar 26-10 16:26): también en el checkout un clic fuera cierra el carrito lateral, y el
  // resumen recupera su ancho. Los avisos (SweetAlert) no cuentan como «fuera».
  const isCheckoutCart = window.location.pathname === '/pages/checkout-cart';
  const container = resolveCartContainer();
  if (
    container?.classList.contains('active') &&
    !container.contains(event.target) &&
    !event.target.closest('#btn-cart-header') &&
    !event.target.closest('.swal2-container') &&
    // B3 (/probar 26-10 17:24): el modal de direcciones del paso 2 se monta en el body
    !event.target.closest('#vtl-addr-modal')
  ) {
    container.classList.remove('active');
    if (isCheckoutCart) document.getElementById('cart-summary')?.classList.add('container');
    sessionStorage.setItem('cart_open_state', '0');
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    // Igual que el botón de cerrar: en el checkout el resumen recupera su ancho
    if (window.location.pathname === '/pages/checkout-cart') document.getElementById('cart-summary')?.classList.add('container');
    resolveCartContainer()?.classList.remove('active');
    sessionStorage.setItem('cart_open_state', '0');
  }
});


const CartSystem = (() => {

  // ── TOAST ─────────────────────────────────────────────────────
  const TOAST_DURATION = 2800;

  function showToast(type, productName) {
    const toast = document.getElementById('cart-toast');
    const msg   = document.getElementById('cart-toast-msg');
    const icon  = document.getElementById('cart-toast-icon');
    if (!toast) return;

    const config = {
      added:   { icon: '+', text: `Agregado: ${productName}`    },
      updated: { icon: '↑', text: `Actualizado: ${productName}` },
      removed: { icon: '×', text: `Eliminado: ${productName}`   },
    };

    const { icon: ic, text } = config[type] || config.updated;

    clearTimeout(toast._hideTimer);
    toast.classList.remove('visible', 'toast--added', 'toast--updated', 'toast--removed');
    icon.textContent = ic;
    msg.textContent  = text;
    toast.classList.add(`toast--${type}`);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => toast.classList.add('visible'));
    });

    toast._hideTimer = setTimeout(() => toast.classList.remove('visible'), TOAST_DURATION);
  }
  // ── TOAST fin ─────────────────────────────────────────────────

  // V15-B10: el mismo formato que el filtro money de Liquid (vtlDinero, en customs-functions.js).
  // Antes salía "$ 56.000" en el subtotal y el total junto a líneas "$32.000,00"
  function formatMoney(cents) {
    if (typeof window.vtlDinero === 'function') return window.vtlDinero(cents);
    return (cents / 100).toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    });
  }

  function setButtonLoading(btn, on) {
    btn.disabled = on;
    btn.style.opacity = on ? '0.4' : '';
  }

  // S4: misma espera máxima que CartView.pedir en el checkout. Sin ella, un change.js
  // que no respondía dejaba el botón deshabilitado y el checkout sin refrescar
  const TIEMPO_LIMITE = 8000;

  async function pedirJson(url, init) {
    const ctrl  = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), TIEMPO_LIMITE);
    try {
      const res = await fetch(url, Object.assign({}, init, { signal: ctrl.signal }));
      if (!res.ok) throw new Error(`Cart API error ${res.status}`);
      return await res.json();
    } finally {
      clearTimeout(timer);
    }
  }

  function apiChange(key, quantity) {
    return pedirJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
  }

  // S4: tras un error el cambio pudo aplicarse igual: se pinta lo que diga el carrito
  async function sincronizarTrasError(key) {
    try {
      if (window.location.pathname === '/pages/checkout-cart' && window.CartView) {
        await window.CartView.refrescar({ sinRecarga: true });
        return;
      }
      const cartData = await pedirJson('/cart.js', { cache: 'no-store' });
      updateItemDOM(key, cartData);
      updateBadge(contarParaBadge(cartData));
      updateTotals(cartData.total_price);
    } catch (e) {
      // Sin red: queda como estaba hasta la siguiente acción
    }
  }

  // N13: el contador no incluye el cargo de domicilio (vtlContarExamenes en customs-functions.js)
  function contarParaBadge(cartData) {
    return typeof window.vtlContarExamenes === 'function' ? window.vtlContarExamenes(cartData) : cartData.item_count;
  }

  function updateBadge(count) {
    document.querySelectorAll('.cart-link__bubble--visible').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';   // P7: sin exámenes no se muestra 0
    });
  }

  function updateTotals(totalPrice) {
    const money = formatMoney(totalPrice);
    getCartScopes().forEach(scope => {
      scope.querySelectorAll('.txt_subtotal_price').forEach(el => {
        el.textContent = money;
      });
      scope.querySelectorAll('.txt_total_price').forEach(el => {
        const strong = el.querySelector('strong');
        if (strong) strong.textContent = money;
        else el.textContent = money;
      });
    });
  }

  function updateItemDOM(key, cartData) {
    const item = cartData.items.find(i => i.key === key);
    const row  = document.querySelector(`.cart-container .cont_item_cart[data-key="${key}"]`);

    if (!row) return;

    if (!item || item.quantity === 0) {
      row.style.transition = 'opacity .22s, transform .22s';
      row.style.opacity    = '0';
      row.style.transform  = 'translateX(10px)';

      let cleaned = false;
      const cleanup = () => {
        if (cleaned) return;
        cleaned = true;
        row.remove();
        checkEmpty(cartData);
        const list = row.closest('.cont_list_cart_items');
        if (list && !list.querySelector('.cont_item_cart')) {
          checkEmpty(cartData);
        }
      };

      row.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(cleanup, 350);
      return;
    }

    const qtyEl   = document.getElementById(`qty-${key}`);
    const priceEl = document.getElementById(`line-price-${key}`);
    const addBtn  = row.querySelector('.btn_add');
    const minBtn  = row.querySelector('.btn_minus');

    if (qtyEl)   qtyEl.textContent   = item.quantity;
    if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);

    if (addBtn) {
      const atMax = item.quantity >= MAX_QTY;
      addBtn.disabled = atMax;
      addBtn.style.opacity = atMax ? '0.35' : '';
      addBtn.style.cursor  = atMax ? 'not-allowed' : '';
      addBtn.setAttribute('aria-disabled', atMax);
    }

    if (minBtn) {
      const atMin = item.quantity <= 1;
      minBtn.disabled = atMin;
      minBtn.style.opacity = atMin ? '0.35' : '';
      minBtn.style.cursor  = atMin ? 'not-allowed' : '';
      minBtn.setAttribute('aria-disabled', atMin);
    }
  }

  function checkEmpty(cartData) {
    if (cartData.item_count > 0) return;
    getCartScopes().forEach(scope => {
      const list = scope.querySelector('.cont_list_cart_items');
      if (list) list.innerHTML = '<p class="cart-empty-msg">Tu carrito está vacío.</p>';
      const paySection = scope.querySelector('.cont_pay_cart');
      if (paySection) paySection.style.display = 'none';
    });
  }

  // C7: devuelve los totales y «Pagar ahora» que checkEmpty ocultó al vaciar el carrito
  function showPaySection() {
    getCartScopes().forEach(scope => {
      const paySection = scope.querySelector('.cont_pay_cart');
      if (paySection) paySection.style.display = '';
    });
  }

  async function changeQuantity(key, newQty, triggerBtn) {
    if (triggerBtn) setButtonLoading(triggerBtn, true);

    // ── TOAST: capturar nombre y qty antes del fetch ──────────
    const row     = document.querySelector(`.cart-container .cont_item_cart[data-key="${key}"]`);
    const name    = row?.querySelector('.title_item_cart')?.textContent?.trim() || 'producto';
    const prevQty = parseInt(document.getElementById(`qty-${key}`)?.textContent || '1');
    // ── TOAST fin captura ─────────────────────────────────────

    try {
      const cartData = await apiChange(key, newQty);

      // ── TOAST: mostrar según tipo de acción ───────────────────
      if (newQty === 0)          showToast('removed', name);
      else if (newQty > prevQty) showToast('added',   name);
      else                       showToast('updated', name);
      // ── TOAST fin ─────────────────────────────────────────────

      updateItemDOM(key, cartData);
      updateBadge(contarParaBadge(cartData));
      updateTotals(cartData.total_price);

      window.CartBus?.emit('cart:changed', { cartData });

      const isCheckoutCart = window.location.pathname === '/pages/checkout-cart';
      if (isCheckoutCart) {
        // Sin recargar: el checkout refresca líneas, totales y paso 2 por su cuenta
        if (window.CartView) await window.CartView.refrescar();
        else location.reload();
      }

    } catch (err) {
      console.error('[CartSystem] Error al actualizar carrito:', err);
      const qtyEl = document.getElementById(`qty-${key}`);
      if (qtyEl) qtyEl.textContent = prevQty;
      await sincronizarTrasError(key);
    } finally {
      if (triggerBtn) setButtonLoading(triggerBtn, false);
    }
  }

  function bindEvents() {
    // N5: se escucha en .cart-container y no en la lista, porque CartView.refrescar()
    // reemplaza la lista del checkout y se perdían los oyentes de la papelera
    document.querySelectorAll('.cart-container').forEach(list => {
      // Umbral en px: por encima de esto el gesto se considera scroll/arrastre,
      // no un tap, por lo que no debe disparar ninguna acción del carrito.
      const TAP_SLOP = 10;
      let touchStart = null;   // { x, y, target }
      let lastTapAt  = 0;      // evita el "ghost click" posterior al touchend

      list.addEventListener('touchstart', e => {
        const t = e.changedTouches[0];
        touchStart = { x: t.clientX, y: t.clientY, target: e.target };
      }, { passive: true });

      list.addEventListener('touchmove', e => {
        if (!touchStart) return;
        const t = e.changedTouches[0];
        if (Math.abs(t.clientX - touchStart.x) > TAP_SLOP ||
            Math.abs(t.clientY - touchStart.y) > TAP_SLOP) {
          touchStart = null;   // el dedo se desplazó: se cancela el tap
        }
      }, { passive: true });

      list.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });

      function isValidTap(e) {
        if (!touchStart) return false;
        const t = e.changedTouches[0];
        if (Math.abs(t.clientX - touchStart.x) > TAP_SLOP ||
            Math.abs(t.clientY - touchStart.y) > TAP_SLOP) return false;

        // El dedo debe levantarse sobre el mismo control donde inició.
        const endTarget = document.elementFromPoint(t.clientX, t.clientY);
        if (!endTarget) return false;
        const startBtn = touchStart.target.closest?.('.btn_minus, .btn_add, .btn-trash-item');
        const endBtn   = endTarget.closest?.('.btn_minus, .btn_add, .btn-trash-item');
        return !!startBtn && startBtn === endBtn;
      }

      function handleCartAction(e) {
        if (e.type === 'touchend') {
          const valid = isValidTap(e);
          touchStart = null;
          if (!valid) return;
          e.preventDefault();
          lastTapAt = Date.now();
        } else if (Date.now() - lastTapAt < 700) {
          // click sintético generado por el touchend ya atendido
          return;
        }

        const minus = e.target.closest('.btn_minus');
        if (minus) {
          const key     = minus.dataset.key;
          const qtyEl   = document.getElementById(`qty-${key}`);
          const current = parseInt(qtyEl?.textContent || '1');
          changeQuantity(key, Math.max(0, current - 1), minus);
          return;
        }

        const plus = e.target.closest('.btn_add');
        if (plus) {
          const key     = plus.dataset.key;
          const qtyEl   = document.getElementById(`qty-${key}`);
          const current = parseInt(qtyEl?.textContent || '1');
          if (current >= MAX_QTY) { showMaxNotice(plus); return; }
          changeQuantity(key, current + 1, plus);
          return;
        }

        const trash = e.target.closest('.btn-trash-item');
        if (trash) {
          // M6: el candado del cargo usa la misma clase y no tiene data-key
          if (trash.classList.contains('btn-trash-item--lock') || !trash.dataset.key) return;
          changeQuantity(trash.dataset.key, 0, trash);
          return;
        }
      }

      list.addEventListener('touchend', handleCartAction, { passive: false });
      list.addEventListener('click',    handleCartAction);
    });
  }

  function showMaxNotice(btn) {
    if (btn.parentElement.querySelector('.cart-max-notice')) return;
    const notice = document.createElement('span');
    notice.className   = 'cart-max-notice';
    notice.textContent = 'Máx. 1';
    btn.insertAdjacentElement('afterend', notice);
    setTimeout(() => notice.remove(), 1800);
  }

  function buildBadgeDelivery(available, label = 'Domicilio') {
    const isAvailable = available === true || available === 'true'
                     || available === 'yes' || available === '1';
    const badgeMod = isAvailable ? 'cart-badge--ok'  : 'cart-badge--no';
    const iconPath = isAvailable ? 'M2 6L5 9L10 3'   : 'M3 3L9 9M9 3L3 9';
    return `
      <span class="cart-badge ${badgeMod}">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="${iconPath}" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        ${label}
      </span>`;
  }

  function buildItemHTML(item) {
    const atMax        = item.quantity >= MAX_QTY;
    const atMin        = item.quantity <= 1;
    // B9: sin la propiedad _req_domicilio (línea agregada por otro camino) no se marca
    // como no disponible; el paso 1 decide por la etiqueta y por defecto lo muestra disponible.
    // B14: los formularios solo mandan '0' para la etiqueta "Req_Domicilio: 0"
    const reqDomicilio = item.properties?._req_domicilio ?? '1';

    return `
      <div class="cont_item_cart" data-key="${item.key}">
        <div class="cont_item_header">
          <div class="header_item_delivery">
            <a href="/products/${item.handle}" class="title_item_cart">
              ${item.product_title}
            </a>
            <div class="cart-line-item__badges">
              ${buildBadgeDelivery(reqDomicilio, 'Domicilio')}
            </div>
          </div>
          <button class="btn-trash-item" data-key="${item.key}" type="button"
                  aria-label="Eliminar ${item.product_title}">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
              <path d="M1 4.5H17M7 4.5V2.5H11V4.5M3 4.5L4 17.5H14L15 4.5H3Z"
                    stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="cont_item_footer">
          <span><strong>Cantidad</strong></span>
          <div class="item_quantity_selector">
            <button class="btn_quantity_cart btn_minus" data-key="${item.key}" type="button"
                    aria-label="Reducir cantidad"
                    ${atMin ? 'disabled aria-disabled="true"' : ''}
                    style="${atMin ? 'opacity:0.35;cursor:not-allowed' : ''}">-</button>
            <span class="item-qty-display" id="qty-${item.key}">${item.quantity}</span>
            <button class="btn_quantity_cart btn_add" data-key="${item.key}" type="button"
                    aria-label="Aumentar cantidad"
                    ${atMax ? 'disabled aria-disabled="true"' : ''}
                    style="${atMax ? 'opacity:0.35;cursor:not-allowed' : ''}">+</button>
          </div>
          <span class="item-line-price" id="line-price-${item.key}">
            ${formatMoney(item.final_line_price)}
          </span>
        </div>
      </div>`;
  }

  function injectOrUpdateItem(item, cartData) {
    getCartScopes().forEach(scope => {
      const list     = scope.querySelector('.cont_list_cart_items');
      const emptyMsg = list?.querySelector('.cart-empty-msg');
      const existing = scope.querySelector(`.cont_item_cart[data-key="${item.key}"]`);

      if (!list) return;

      if (existing) {
        const qtyEl    = document.getElementById(`qty-${item.key}`);
        const priceEl  = document.getElementById(`line-price-${item.key}`);
        const itemData = cartData.items.find(i => i.key === item.key);
        if (qtyEl && itemData)   qtyEl.textContent  = itemData.quantity;
        if (priceEl && itemData) priceEl.textContent = formatMoney(itemData.final_line_price);
        return;
      }

      emptyMsg?.remove();
      list.insertAdjacentHTML('afterbegin', buildItemHTML(item));
    });
  }

  function init() {
    bindEvents();

    document.addEventListener('cart:updated', ({ detail }) => {
      const { item, cartData } = detail;
      if (item && cartData) {
        injectOrUpdateItem(item, cartData);
        // ── TOAST: producto agregado desde fuera del carrito ──
        showToast('added', item.product_title || 'producto');
      }
      if (cartData?.item_count  !== undefined) updateBadge(contarParaBadge(cartData));
      if (cartData?.total_price !== undefined) updateTotals(cartData.total_price);
      // C7: aquí y no en injectOrUpdateItem: syncCartUI (customs-functions.js) corre antes y ya
      // pintó la línea nueva, así que injectOrUpdateItem la encontraba y salía sin mostrar
      // el botón. Además, algunos cart:updated llegan sin item.
      if (cartData?.item_count > 0) showPaySection();
    });
  }

  return { init, openCart, showToast };

})();

// ─── Exponer API global ───────────────────────────────────────
window.header = { openCart };

// P1/Q8: con defer el script corre con el HTML ya leído (readyState 'interactive'),
// así que se inicia de una vez, antes de DOMContentLoaded. El oyente queda por si
// el script vuelve a cargarse sin defer; con async se perdía el evento y la
// papelera y el ± del carrito quedaban sin manejador
function iniciarCarritoHeader() {
  restoreCartState();
  CartSystem.init();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', iniciarCarritoHeader);
} else {
  iniciarCarritoHeader();
}
